module.exports = __webpack_public_path__ + "static/media/hemp.5d8ce321.jpg";